import script from "./PurchasedProductDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchasedProductDetails.vue?vue&type=script&setup=true&lang=js"

import "./PurchasedProductDetails.vue?vue&type=style&index=0&id=0f5d5a14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f5d5a14"]])

export default __exports__